export const formatToPhoneNumber = (input: string): string => {
  const digitsOnly = input.replace(/\D/g, ''); // 숫자만 추출
  if (digitsOnly.length !== 11) return input; // 예: 01012345678 → 11자리
  return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 7)}-${digitsOnly.slice(7)}`;
};
